import { render, staticRenderFns } from "./view-receipt.vue?vue&type=template&id=401c43bb&scoped=true&"
import script from "./view-receipt.vue?vue&type=script&lang=js&"
export * from "./view-receipt.vue?vue&type=script&lang=js&"
import style0 from "./view-receipt.vue?vue&type=style&index=0&id=401c43bb&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401c43bb",
  null
  
)

export default component.exports